import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'infra-first_contentful_paint-view';
/**
 * General event for capturing the First Contentful Paint (FCP) metric.
 */
export function trackInfraFirstContentfulPaintView(name, loadType2, fcp3, attribution4, manualOverrides) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        manualOverrides: manualOverrides,
        parameters: { name, loadType2, fcp3, attribution4 },
    });
}
